import { createApp } from 'vue'
import { createRouter } from '@/router'
import store from './store/index.js'


/* swiper */
// import 'swiper/swiper.min.css'

/* 重置样式 */
import './assets/css/reset.min.css'

// import 'jquery'

// import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min.js'

/* animate.css */
import 'wow.js/css/libs/animate.css'

/* i18n */
import I18n from './language/i18n.ts'

/* tailwindcss */
// import './assets/css/tailwind.css'
import 'tailwindcss/tailwind.css'

import axios from './utils/Promisehttp.ts'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import App from './App.vue'

const router = createRouter()
const app = createApp(App)
  .use(I18n)
  .use(ElementPlus)
  .use(store)
app.config.globalProperties= {
  $api: axios,
};

app.use(router).mount('#app')

